import { useState } from 'react';
import { Vehicle } from 'types/vehicle';
import { useAdminOfferAuction } from '.';
import { formatCurrency } from 'utils';

type GetAlternativeCounter = () => {
  firstCounterRow: string;
  secondCounterRow: string;
  thirdCounterRow: string;
  hasAtLeastOneCounter: boolean;
};

export const useGetAdminAACounterInfo = (vehicle: Vehicle): GetAlternativeCounter => {
  const offerAuction = useAdminOfferAuction(vehicle.id);

  return () => {
    const firstCounterRow = (() => {
      const adminPublicCounter = offerAuction?.privateOffers?.find(el => el.is_admin && el.type === 'public');

      return `AA - ${formatCurrency(adminPublicCounter?.amount ?? 0)}`;
    })();

    const secondCounterRow = (() => {
      const publicSellerCounter = offerAuction?.privateOffers?.find(el => !el.is_admin && el.type === 'public');

      if (publicSellerCounter) {
        return `S - ${formatCurrency(publicSellerCounter.amount)}`;
      }
      const lastNonBuyerPrivateCounter = offerAuction?.privateOffers?.find(
        el => el.sender.role !== 'buyer' && el.type === 'private'
      );
      let prefix = 'S';

      if (lastNonBuyerPrivateCounter && lastNonBuyerPrivateCounter.is_admin) {
        prefix = 'AA';
      }

      return `${prefix} - ${formatCurrency(lastNonBuyerPrivateCounter?.amount ?? 0)}`;
    })();

    const buyerCounter = offerAuction?.privateOffers?.find(el => el.sender.role === 'buyer')?.amount;

    const thirdCounterRow = `B - ${formatCurrency(buyerCounter ?? 0)}`;

    const hasAtLeastOneCounter = !!offerAuction?.privateOffers && offerAuction.privateOffers.length > 0;

    return { firstCounterRow, secondCounterRow, thirdCounterRow, hasAtLeastOneCounter };
  };
};

export const useGetAdminAlternativeCounterInfo = (vehicle: Vehicle): GetAlternativeCounter => {
  return () => {
    const firstCounterRow = `AA - ${formatCurrency(vehicle.admin_alternative_offer?.amount ?? 0)}`;

    const secondCounterRow = `S - ${formatCurrency(vehicle.seller_alternative_offer?.amount ?? 0)}`;

    const buyerCounter = vehicle.top_alternative_bid_offer?.amount;

    const thirdCounterRow = `B - ${formatCurrency(buyerCounter ?? 0)}`;

    const hasAtLeastOneCounter = !!vehicle.top_alternative_bid_offer || !!vehicle.active_alternative_offer;

    return { firstCounterRow, secondCounterRow, thirdCounterRow, hasAtLeastOneCounter };
  };
};
